import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/orderss/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { INVENTORY_SORT, PRODUCT_SORT, TRANG_THAI_BAN_HANG } from '../../constants/productStatus';
import InputTitleTop from '../../components/InputTitleTop';
import SelectTitleTop from '../../components/SelectTitleTop';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import FileDownload from 'js-file-download'
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import IconLock from '../../assets/images/icon-lock.png';
import IconUnLock from '../../assets/images/icon-unlock.png';
import IconPlus from '../../assets/images/icon-plus.png';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import { ProductType } from '../product/ProductList';
import { PaymentStatusList } from '../designation/DesignationList';
import IconCalendarBlack from '../../assets/images/icon/ic_calendar-black.svg';
import IconDolla from '../../assets/images/icon_dolla.png';
import TextUtils from '../../helpers/TextUtils';
import ReceiptsAdd from '../receipts/ReceiptsAdd';
import paymentProcesss from '../../assets/images/payment/process.png';
import paymentDone from '../../assets/images/payment/done.png';
import paymentSPos from '../../assets/images/payment/spos.png';
import paymentVNPayQR from '../../assets/images/payment/vnpay_qrcode.png';
import profilePic from '../../assets/images/users/no-img.jpg';
import { ReceiptsStatusList } from '../receipts/ReceiptsList';

export const StatusList:any = [
    {
        value:0,
        time:'created_time',
        label: "Mới"
    },
    {
        value:5,
        time:'quotation_time',
        label: "Báo giá"
    },
    {
        value:1,
        time:'active_time',
        label: "Xác nhận"
    },
    {
        value:2,
        time:'export_time',
        label: "Xuất kho"
    },
    {
        value:3,
        time:'done_time',
        label: "Hoàn thành"
    },
    {
        value:4,
        time:'return_time',
        label: "Chuyển hoàn"
    },
    {
        value:-1,
        time:'cancel_time',
        label: "Đã hủy"
    },
]

export const orderType:any = [
    {
        value:'pos',
        label: "Offline"
    },
    {
        value:'online',
        label: "Online"
    },
]

export const ReasonList:any = [
    {
        value:1,
        label: "Khách hàng yêu cầu hủy"
    },
    {
        value:2,
        label: "Khách đổi ý sửa đơn "
    },
    {
        value:3,
        label: "Đổi kho xuất"
    },
    {
        value:4,
        label: "Hết hàng"
    },
    {
        value:5,
        label: "Khác"
    },
]

const configPage = {
    titlePage: 'Danh sách đơn hàng',
    pathPage: '/order',
    column: 10,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {}
}


const List: React.FC<Props> = (props: Props) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>({});
    const [users, setUsers] = useState<any>([]);
    const [branch, setBranch] = useState<any>([]);
    const [saleChannel, setSaleChannel] = useState<any>([]);
    
    
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
        getFilterParams()
        loadInit()
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const getFilterParams = () => {
        const newFilter: any = {}
        if (!isEmpty(searchPrams)) {
            Object.keys(searchPrams).map(function (key) {
                switch (key) {
                    case 'page':
                        setPage(Number(searchPrams[key]))
                        break;
                    case 'limit':
                        setLimit(Number(searchPrams[key]))
                        break;
                    default:
                        newFilter[key] = searchPrams[key]
                        break;
                }
            });
            setFilter(newFilter)
        }
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseUser,
            responseBranch,
            responseSalesCahnnel,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/user`, params),
            APIClient.GET(`${baseUrl}/branch`, params),
            APIClient.GET(`${baseUrl}/sales-channel`, params),
        ]);
        if (responseUser.response?.data !== undefined) {
            let ListArr:any = [];
            responseUser.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setUsers(ListArr)
        }
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
        if (responseSalesCahnnel.response?.data !== undefined) {
            let ListArr:any = [];
            responseSalesCahnnel.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSaleChannel(ListArr)
        }
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: page,
            limit: limit,
            role: 'user',
            ...filter,
        }
        if(formData?.name === "") delete formData?.name
        if(formData?.order_type === "") delete formData?.order_type
        if(formData?.order_type === "") delete formData?.order_type
        if(formData?.branch_id === "") delete formData?.branch_id
        if(formData?.created_uid === "") delete formData?.created_uid
        if(formData?.from && formData?.to) {
            formData.from = moment(formData?.from).startOf('day').valueOf()
            formData.to = moment(formData?.to).endOf('day').valueOf()
        }
        const url = `${baseUrl}/orders`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response?.response?.data)
            setTotalElements(response?.response?.total)
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    user={props?.user}
                    users={users}
                    saleChannel={saleChannel}
                    branch={branch}
                    configPage={configPage}
                    setFilter={(filter: any) => setFilter(filter)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <Pagination
                    link={configPage.pathPage + '/list'}
                    setPage={(page: number) => setPage(page)}
                    page={page}
                    limit={limit}
                    setLimit={(limit: number) => setLimit(limit)}
                    totalElements={totalElements}
                />
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {action?.type === 'addReceipts' ? 
                    <ReceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()} orders_id={action?.orders_id} orders_ids={action?.orders_ids} />:
                    <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
                }
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, configPage, handleActionModal} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (    
            <thead>
                <tr>
                    <th style={{ minWidth: 100}}>Mã đơn</th>
                    <th style={{ minWidth: 100}}>Mã BSO</th>
                    <th style={{ minWidth: 100 }}>Nguồn đơn</th>
                    <th style={{ minWidth: 110 }}>Bệnh nhân</th>
                    <th style={{ minWidth: 110 }}>Tổng tiền</th>
                    <th style={{ minWidth: 120 }}>Giảm giá</th>
                    <th style={{ minWidth: 140 }}>Phải thu khách</th>
                    <th style={{ minWidth: 120 }}>Khách đã trả</th>
                    <th style={{ minWidth: 95 }}>Trạng thái</th>
                    <th style={{ minWidth: 110 }} >Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có đơn hàng nào!" />;
        }

        const gotoDetail = (item:any) => {
            router?.push(`/order/${item?.id}/view`)
            // if(item?.type === 'online'){
            //     router?.push(`/order/${item?.id}/view`)
            //     return
            // }
            // router?.push(`/orderpos/${item?.id}/view`)
        }

        return (
            <tbody>
                {data && data?.length > 0 && data?.map((item: any, index: number) => {
                    const total_payment = item?.orders_payment?.reduce((prevPay:any, itemPay:any)=>{
                        prevPay = prevPay + Number(itemPay?.payment_total)
                        return prevPay
                    },0)
                        return(
                            <tr key={`${item?.id}-${index}`}>
                                <td style={{ minWidth: 100}} onClick={() => gotoDetail(item)}>{item?.code}</td>
                                <td style={{ minWidth: 100}} onClick={() => gotoDetail(item)}>{item?.erp_order_bso || '---'}</td>
                                <td onClick={() => gotoDetail(item)}>{item?.ordersource_id?.name || "---"}</td>
                                <td onClick={() => gotoDetail(item)}>{item?.customer_id?.name}</td>
                                <td onClick={() => gotoDetail(item)}>{PriceUtils.format(item?.total || 0)}</td>
                                <td onClick={() => gotoDetail(item)}>{PriceUtils.format(item?.discount || 0)}</td>
                                <td onClick={() => gotoDetail(item)}>{PriceUtils.format((item?.sub_total || 0))}</td>
                                <td onClick={() => gotoDetail(item)}>{PriceUtils.format(total_payment || 0)}</td>
                                <td onClick={() => gotoDetail(item)}>
                                    <span className={
                                        item?.status == 4 ? 'text-dark' :
                                        item?.status == 3 ? 'text-success' :
                                        item?.status == 2 ? 'text-success' :
                                        item?.status == 1 ? 'text-info' :
                                        item?.status == 5 ? 'text-info' :
                                        item?.status == 0 ? 'text-dark' :
                                        item?.status == -1 ? 'text-danger':
                                        ""
                                    }>{
                                        item?.status == 4 ? "Chuyển hoàn" :
                                        item?.status == 3 ? "Hoàn thành" :
                                        item?.status == 2 ? "Xuất kho" :
                                        item?.status == 1 ? "Xác nhận" :
                                        item?.status == 0 ? "Mới" :
                                        item?.status == 5 ? "Báo giá" :
                                        item?.status == -1 && "Đã hủy" 
                                    }</span>
                                </td>
                                <td>
                                    <div className="table-action">
                                        {(item?.status !== -1 && item?.status !== 0) && item?.payment_status !== 'paid' && 
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'addReceipts', orders_id: item?.id, })}><img style={{border: 'none'}} src={IconDolla} width={20} height={20} alt=""/></div>
                                        }
                                        {item?.status === 0 && 
                                        // <div className="button-nutri" onClick={() => router?.push(`/order/${item?.id}`)}>
                                        //     <img style={{border: 'none'}} src={IconEdit} width={20} height={20} alt=""/>
                                        // </div>
                                        <div className="button-nutri">
                                            <img style={{border: 'none'}} src={IconEdit} width={20} height={20} alt="" onClick={() => router?.push(`/order/${item?.id}`)}/>
                                        </div>
                                        }
                                        {item?.status === 0 && 
                                            <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'reject', data: item})}><i className='uil-trash-alt'></i></div>
                                        }
                                    </div>
                                </td>
                            </tr>
                        )
                })}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
        </div>
    );
};

const DataFilter = (props: any) => {
    const { setFilter, filter, users, branch, saleChannel, user} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value,
            })
        }
    }

    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        setFilter({
            ...filter,
            page: 1,
            [name]: value
        })
    }

    const handleChangeFilterDate = (date:any) => {
        if(date.length === 2){
            const from = moment(date[0]).startOf("day").format('YYYY-MM-DD')
            const to = moment(date[1]).endOf("day").format('YYYY-MM-DD')
            setFilter({
                ...filter,
                from:from,
                to:to
            })
        }else if(date.length === 0){
            setFilter({
                ...filter,
                from:undefined,
                to:undefined
            })
        }   
    }

    const handleFilterMulti = (name:string, option:any, onChange:any)=> {
        const value:any = []
        option&&option.map((item:any)=>{
            value.push(item.value)
        })
        onChange({ target:{ name, value}})
        
    }

    const getFilterMulti = (list:any,value:any)=>{
        if (value instanceof Array){
            const option:any = []
            list&&list.map((item:any)=>{
                const found = value.length >0 && value.find((element:any) => element == item.value);
                if(found || found === 0){
                    option.push(item)
                }
            })
            return option
        }
        return []
    }
    
    let STATUS = StatusList
    if(user?.store_id?.is_erp_stock){
        STATUS = StatusList?.filter((item:any)=> item?.value !== 2 && item?.value !== 4)
    }
    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={12}>
                        <Row>
                            <Col xl={4}>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                        <img src={IconSearch} width={18} height={18} alt=""/>
                                    </InputGroupAddon>
                                    <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tên khách hàng hoặc số điện thoại, mã đơn" />
                                </InputGroup>
                            </Col>
                            <Col xl={2}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Loại đơn-"
                                    options={[{
                                        value: '',
                                        label: "-Loại đơn-",
                                    }, ...orderType]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'type', value: value.value } })
                                    }}
                                    value={orderType?.filter((option: any) => filter?.type == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Nguồn đơn-"
                                    options={[{
                                        value: '',
                                        label: "-Nguồn đơn-",
                                    }, ...saleChannel]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'sales_channel_id', value: value.value } })
                                    }}
                                    value={saleChannel?.filter((option: any) => filter?.sales_channel_id == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái thanh toán-"
                                    options={PaymentStatusList}
                                    isMulti
                                    onChange={(val:any) => { handleFilterMulti('payment_statuses', val, handleChange) }}
                                    value={getFilterMulti(PaymentStatusList,filter?.payment_statuses || [])}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Trạng thái đơn-"
                                    options={STATUS}
                                    isMulti
                                    onChange={(val:any) => { handleFilterMulti('statuses', val, handleChange) }}
                                    value={getFilterMulti(STATUS,filter?.statuses || [])}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <InputGroup className='form-control picker-custom'>
                                    <Flatpickr 
                                        value={[new Date(moment(filter?.from,'YYYY-MM-DD').startOf('day').valueOf()),
                                         new Date(moment(filter?.to,'YYYY-MM-DD').startOf('day').valueOf())]}
                                        onChange={(date:any) => { handleChangeFilterDate(date) }} 
                                        options={{
                                            mode: "range",
                                            locale: Vietnamese,
                                            dateFormat: "d/m/Y",
                                        }}
                                        className="flatpickr-input active"
                                        placeholder="Thời gian tạo"
                                    />
                                    <div className="icon-clear" style={{right:23}} onClick={()=>{setFilter({...filter, from: null, to:null})}}>
                                        <i className="uil-times mr-1"></i>
                                    </div>
                                    <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                            <img src={IconCalendarBlack} alt="icon" />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Cơ sở bán-"
                                    options={[{
                                        value: "",
                                        label: "-Cơ sở bán-",
                                    },...branch]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'branch_id', value: value.value } })
                                    }}
                                    value={branch?.filter((option: any) => filter?.branch_id == option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Người tạo-"
                                    options={[{
                                        value: "",
                                        label: "-Người tạo-",
                                    },...users]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'created_uid', value: value.value } })
                                    }}
                                    value={users?.filter((option: any) => filter?.created_uid == option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Link to={`/order/add`}>
                        <Button color="success" className="ml-2">
                            <img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  
                            Thêm
                        </Button>
                    </Link>
                </div>
            </Col>
        </Row>
    );
};

export const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const [reasonId, setReasonId] = useState();
    const [reasonContent, setReasonContent] = useState('');
    const { closeModal, action, loadData, paymentSynce } = props
    const router=useHistory()

    const handleQuotation = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 5
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Gửi báo giá thành công!')
            closeModal()
            loadData()
        }
    }

    const handleActive = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 1
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xác nhận nhập hàng thành công!')
            closeModal()
            loadData()
        }
    }

    const handleReject = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: -1,
            reason_cancel: reasonId,
            reason_content: reasonId === 4 ? reasonContent : undefined,
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) { 
            toast.success('Hủy phiếu nhập hàng thành công!')
            closeModal()
            loadData()
        }
    }

    const handleImport = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 2
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Nhập kho thành công!')
            closeModal()
            loadData()
        }
    }

    const handleReturn = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 4
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Chuyển hoàn thành công!')
            closeModal()
            loadData()
        }
    }

    const handleDone = async() => {
        setLoading(true)
        const url = `${baseUrl}/orders/status/${action?.data?.id}`;
        let response: any = await APIClient.PUT(url,{
            status: 3
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Hoàn thành đơn thành công!')
            closeModal()
            loadData()
        }
    }

    const handleConfirm = async() => {
        action?.onSubmit()
        closeModal()
    }

    const handleUpdatePrice = async() => {
        action?.onSubmit()
        closeModal()
    }

    return (
        <CardBody className='p-0' style={{width:action?.type === 'paymentProcess'? 500 :action?.type === 'reject' ? 460:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    {(action?.type === 'quotation' || action?.type === 'quotationConfirm') && "Báo giá đơn hàng"}
                    {(action?.type === 'active' || action?.type === 'activeConfirm') && "Xác nhận đơn hàng"}
                    {action?.type === 'reject' && "Hủy đơn hàng"}
                    {(action?.type === 'export' || action?.type === 'exportConfirm') && "Xuất kho"}
                    {action?.type === 'return' && "Chuyển hoàn"}
                    {action?.type === 'done' && "Hoàn thành"}
                    {action?.type === 'updatePrice' && "Cập nhật giá"}
                    {action?.type === 'paymentProcess' && "Xử lý thanh toán"}
                    {action?.type === 'receiptsUpdateStatusConfirm' && "Cập nhật trạng thái"}
                </h5>
                <button onClick={()=>{
                    action?.type === 'paymentProcess' && handleConfirm()
                    closeModal()
                }} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-2 pb-2">
                <Col md={12}>
                    <FormGroup row className="label-only">
                        {(action?.type === 'quotation' || action?.type === 'quotationConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn báo giá đơn hàng này?</p>
                        }
                         {(action?.type === 'active' || action?.type === 'activeConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn xác nhận đơn hàng này?</p>
                        }
                        {(action?.type === 'export' || action?.type === 'exportConfirm') &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn chuyển trạng thái Xuất kho cho đơn hàng này?</p>
                        }
                        {action?.type === 'return' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn chuyển hoàn đơn hàng này?</p>
                        }
                        {action?.type === 'done' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn hoàn thành đơn hàng này?</p>
                        }
                        {action?.type === 'updatePrice' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>{`Có ${action?.data?.orders_products_is_updated?.length} sản phẩm trong đơn hàng đã thay đổi giá. Vui lòng nhấn Cập nhật để nhận giá mới`}</p>
                        }
                        {action?.type === 'receiptsUpdateStatusConfirm' &&
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>{`Bạn có chắc chắn muốn chuyển phiếu thu sang trạng thái ${action?.data?.statusText} ?`}</p>
                        }
                        {action?.type === 'paymentProcess' &&
                        <div className='payment-sync'>
                            {paymentSynce?.map((item:any)=>{
                                return (
                                    <div className={`payment-sync-item ${item?.status === 1 ? 'done' : item?.status === -1 ? 'cancel':''}`}>
                                        <span className='payment-sync-img'>
                                            <img  src={item?.is_vnpay_qr ? paymentVNPayQR : item?.is_vnpay_sppos ? paymentSPos: paymentDone }/>
                                        </span>
                                        <span className='payment-sync-payment_method'>{item?.payment_method_id?.name}</span>
                                        <span className='payment-sync-payment_total'>{PriceUtils.format(item?.payment_total, ' đ')}</span>
                                        <span className='payment-sync-status'>{TextUtils.getLabelByValue(ReceiptsStatusList, item?.status)}</span>
                                    </div>
                                )
                            })}
                        </div>
                        }
                    </FormGroup>
                </Col>
                {action?.type === 'reject' &&
                <>
                    {/* <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>Bạn có chắc chắn muốn Hủy đơn hàng này?</p> */}
                    <Row className='p-2'>
                        <Col md={12} xs={12}>
                            <FormGroup>
                                <Label>Lý do hủy đơn hàng</Label>
                                <InputGroup>
                                    <Select
                                        placeholder="Chọn lý do hủy"
                                        className="react-select select-icon select-full"
                                        classNamePrefix="react-select"
                                        maxMenuHeight={250}
                                        onChange={(val: any) => {
                                            setReasonId(val?.value)
                                        }}
                                        value={ReasonList?.filter(
                                            (option: any) => reasonId == option.value
                                        )}
                                        options={ReasonList}
                                    ></Select>
                                </InputGroup>
                            </FormGroup>
                            {reasonId === 5 &&
                            <FormGroup>
                                <Label>Lý do khác</Label>
                                <InputGroup>
                                    <Input type="textarea" rows={4} value={reasonContent} onChange={(e: any) => setReasonContent(e?.target?.value)} name="reasonContent" placeholder="Nhập lý do khác" />
                                </InputGroup>
                            </FormGroup>}
                        </Col>
                    </Row>
                </>
                }
            </div>
            {action?.type !== "paymentProcess" &&
            <div className="modal-footer">
                {/* <Button
                    onClick={closeModal}
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button> */}
                <Button
                    onClick={()=>{
                        action?.type === 'active' && handleActive()
                        action?.type === 'activeConfirm' && handleConfirm()
                        action?.type === 'quotation' && handleQuotation()
                        action?.type === 'quotationConfirm' && handleConfirm()
                        action?.type === 'reject' && handleReject()
                        action?.type === 'export' && handleImport()
                        action?.type === 'exportConfirm' && handleConfirm()
                        action?.type === 'return' && handleReturn()
                        action?.type === 'done' && handleDone()
                        action?.type === 'updatePrice' && handleUpdatePrice()
                        action?.type === 'receiptsUpdateStatusConfirm' && handleConfirm()
                        
                    }}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>}
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)